import React from "react";
import { Content as StyledContent } from "./styles";

export const Content: React.FC = (props) => <StyledContent {...props} />;
